module.exports = __webpack_public_path__ + "static/img/team-bg.87963ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/team-bg.png
// module id = ksU0
// module chunks = 0